import React, { useState } from 'react';
import CircleButton, {
  getCircleButtonClass,
} from 'components/v2/buttons/CircleButton';
import { Calendar } from 'lucide-react';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import AddAppointmentModal from 'components/ui/tailwind/modals/AddAppointmentModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';

export default function AppointmentWindowNextSteps({ item, shipment }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { stops } = shipment;
  const stop = stops.find((s) => s._id === item?.meta?.stop);

  const renderAppointmentLabel = (stop) => {
    const window = item.field === 'window_start' ? 'SET' : 'CONFIRM';
    const offsite = stop?.off_site ? '_OFFSITE' : '';
    const empty = stop?.empty ? '_EMPTY' : '';
    const action = stop?.action === 'deliver' ? '_DELIVERY' : '_PICKUP';
    return `${window}${offsite}${empty}${action}`;
  };

  const renderIcon = () => {
    return !item.complete ? (
      <Calendar className="w-5 h-5" />
    ) : (
      <div
        data-testid="div-9910d49b"
        className={getCircleButtonClass({ size: 'small', color: 'brand' })}
      >
        <CheckIcon />
      </div>
    );
  };

  const handleSave = (data) => {
    ShipmentsActionCreators.updateShipmentStopWindow(shipment, stop, data);
    setShowModal(false);
  };

  return (
    <div data-testid="div-3270aa78">
      <div
        data-testid="div-34780d8c"
        className="flex justify-between text-sm text-gray-700  py-1 items-center"
      >
        <span data-testid="span-80f0c201">
          {t(renderAppointmentLabel(stop))}
        </span>

        <CircleButton
          dataTestId="CircleButton-8a7f73f4"
          size="small"
          disabled={item.complete}
          onClick={() => setShowModal(true)}
        >
          {renderIcon()}
        </CircleButton>
      </div>
      {showModal && (
        <AddAppointmentModal
          dataTestId="AddAppointmentModal-182483dd"
          show={showModal}
          stop={stop}
          shipment={shipment}
          onSave={handleSave}
          onHide={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
